import React from 'react';
import { Link } from 'react-router-dom';
import './Customers.css';
import { clients, testimonials, stats, caseStudies } from '../data/site';

const Customers = () => {
  const featuredCases = caseStudies.slice(0, 6);

  return (
    <div className="customers-page page-shell">
      <section className="cu-hero section-dark">
        <span className="aurora-orb hero-orb-a" />
        <span className="aurora-orb hero-orb-b" />
        <div className="site-container-wide">
          <span className="section-eyebrow">Customers</span>
          <h1>
            Demanding environments. <span className="gradient-text serif-accent">One senior-led delivery model.</span>
          </h1>
          <p>
            Banks, hospitals, retailers, manufacturers, energy operators and SaaS platforms bring
            similar AI and data problems: fragmented systems, measurable outcomes, and production risk.
          </p>
          <div className="cu-stats">
            {stats.global.slice(0, 4).map((s) => (
              <div key={s.label}><strong>{s.value}</strong><span>{s.label}</span></div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="site-container-wide">
          <span className="section-eyebrow">Representative work</span>
          <h2 className="section-title">A representative slice of the environments we support.</h2>
          <div className="cu-clients-grid">
            {clients.map((c) => (<div className="cu-client-cell" key={c}>{c}</div>))}
          </div>
        </div>
      </section>

      <section className="section cu-testimonials section-dark">
        <div className="site-container-wide">
          <span className="section-eyebrow">In their words</span>
          <h2 className="section-title">Voices of clients in production.</h2>
          <div className="cu-testimonials-grid">
            {testimonials.map((t) => (
              <article className="glass-card cu-testimonial" key={t.author}>
                <p>{t.quote}</p>
                <div>
                  <strong>{t.author}</strong>
                  <span>{t.role}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="site-container-wide">
          <div className="section-head-row">
            <div>
              <span className="section-eyebrow">Featured outcomes</span>
              <h2 className="section-title">A glimpse of recent client outcomes.</h2>
            </div>
            <Link to="/case-studies" className="btn-outline btn-arrow">All case studies</Link>
          </div>
          <div className="cu-cases-grid">
            {featuredCases.map((cs) => (
              <Link to={`/case-studies/${cs.id}`} className="cu-case-card professional-card" key={cs.id}>
                <img src={cs.image} alt={cs.title} />
                <div>
                  <span className="eyebrow-tag">{cs.industry}</span>
                  <h3>{cs.title}</h3>
                  <strong>{cs.metric}</strong>
                  <span className="cu-case-meta">{cs.metricLabel}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="cu-cta">
        <div className="site-container-wide professional-card">
          <h2>Want to see what we could do together?</h2>
          <p>Tell us your goal. We will share a tailored briefing within 48 hours.</p>
          <Link to="/contact" className="btn-primary-large">Contact Dalytix</Link>
        </div>
      </section>
    </div>
  );
};

export default Customers;
